import React from "react";
import D01 from "../Pageblock/D01";
export default function Main({ basicData }) {
  return (
    <div>
      <D01 basicPageData={basicData} />
    </div>
  );
}
